import React from 'react'
import "./TokenModal.css";

export default function TokenModal(props) {

    const closeModal = ()=>{
        props.setIsModalOpen(false);
    }

  return (
    <>
        <div className='modal-overlay'>
            <div className='token-modal'>

                {/* Header */}
                <div className='token-modal-header'>
                    <h4>Discount Details</h4>
                    <h3 onClick={()=>closeModal()}>&times;</h3> {/* You can use the × symbol for a better-looking close button */}
                </div>

                {/* Note */}
                <div className='token-modal-note'>
                    <h4>Note :</h4>
                    <p>
                        You will get the token based on the amount of the request you made.
                    </p>
                </div>

                {/* Table */}
                {/* <div className='token-table'>
                    <table>
                        <thead>
                            <tr>
                                <th>Requests</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Food Request</td>
                                <td>123 Rs.</td>
                            </tr>
                            <tr>
                                <td>Food Request</td>
                                <td>123 Rs.</td>
                            </tr>
                            <tr>
                                <td>Food Request</td>
                                <td>123 Rs.</td>
                            </tr>
    
                        </tbody>
                    </table>
                </div> */}

                {/* Total */}
                <div className='token-modal-total'>
                    {/* <div className='token-total-data'>
                        <h4>Total :</h4>
                        <h4>1234 Rs.</h4>
                    </div> */}
                    <div className='token-total-data'>
                        <h4>Tokens you get :</h4>
                        <h4>20</h4>
                    </div>
                    <div className='token-total-data'>
                        <h4>Number of Requests :</h4>
                        <h4>20</h4>
                    </div>
                </div>

                {/* Button */}
                {/* <div className='token-modal-btn'>
                    <button>
                        Redeem Tokens
                    </button>
                </div> */}


            </div>
        </div> 
    </>
  )
}
